import Ajax from "base/Ajax";
import { LogDataTransport } from "logging/LogDataTransport";

export default class AjaxLogTransport extends LogDataTransport {

    constructor() {
        super();
        this.failed = false;
    }

    sendLog(logData) {
        if (this.failed) {
            return;
        }

        Ajax.post("base", "logging", logData).then(() => {
            //NOOP
        }).catch((e) => {
            console.error("Couldn't submit client log", arguments, e);
            this.failed = true;
        });
    }
}
